export const simpleLogoSolid = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 261.7 97.3"
  >
    <g>
      <g>
        <g>
          <path
            style={{ fill: '#223320' }}
            d="M117.3,0.1L111.7,0c0,0,0,0-0.1,0l-2.7,0.2c0,0,0,0-0.1,0l-2.2,0c-0.4,0-0.8,0.3-0.8,0.7l-0.1,2.5
				c0,0.4,0.3,0.8,0.8,0.8l2.1,0c0,0,0,0,0.1,0l1.6-0.1c0.5,0,0.8,0.4,0.8,0.8L111,6.8c0,0,0,0.1,0,0.1l0.3,2.8c0,0,0,0.1,0,0.1
				l-0.2,2.8c0,0,0,0.1,0,0.1l0.1,2.8c0,0,0,0.1,0,0.1l-0.2,2.3c0,0.5,0.3,0.8,0.8,0.8l2.5-0.1c0.4,0,0.7-0.3,0.7-0.7l0.1-2.3
				c0,0,0-0.1,0-0.1l-0.2-2.8c0,0,0-0.1,0-0.1l0.2-2.8c0,0,0,0,0-0.1L115,6.8l0-1.9c0-0.4,0.4-0.8,0.8-0.8l1.6,0.1c0,0,0.1,0,0.1,0
				l2.1-0.1c0.4,0,0.8-0.4,0.7-0.8l-0.1-2.5c0-0.4-0.3-0.7-0.7-0.7L117.3,0.1z"
          />
        </g>
        <g>
          <path
            style={{ fill: '#223320' }}
            d="M138.5,3.4l-0.1-2.1c0-0.5-0.4-1-1-1l-1.9-0.1c-0.6,0-1.1,0.5-1.1,1.1l0.1,2.6c0,0,0,0,0,0.1l0,2.3
				c0,0.6-0.4,1-1,1l-1.4,0.1c0,0,0,0-0.1,0l-3.8-0.1c-0.6,0-1-0.5-1-1l0.1-5c0-0.6-0.5-1-1-1l-1.9,0c-0.6,0-1.1,0.5-1,1.1l0.1,2.1
				c0,0,0,0.1,0,0.1l0,3l-0.1,3l0,3l-0.1,3c0,0,0,0.1,0,0.1l0.2,2.1c0,0.5,0.5,0.9,1,0.9l2,0.1c0.6,0,1-0.4,1.1-1l0.1-1.7
				c0-0.1,0-0.1,0-0.2l-0.2-2.3c0-0.1,0-0.1,0-0.2l0.1-1.2c0-0.6,0.5-1,1.1-1l1.2,0c0,0,0.1,0,0.1,0l2.3-0.2c0.1,0,0.1,0,0.2,0
				l1.3,0.1c0.5,0,0.9,0.4,0.9,0.9l0.2,1.3c0,0.1,0,0.1,0,0.2l-0.2,2.4c0,0,0,0.1,0,0.1l0,1.8c0,0.6,0.5,1,1,1l2.1,0
				c0.6,0,1.1-0.5,1-1.1l-0.2-8.3L138.5,3.4z"
          />
        </g>
        <g>
          <path
            style={{ fill: '#223320' }}
            d="M156.1,15.4c0-0.4-0.3-0.7-0.7-0.7l-2.7,0l-3.1,0l-2.3,0.1c-0.4,0-0.7-0.3-0.7-0.6l-0.1-1.4c0,0,0-0.1,0-0.1
				l0.1-1.4c0-0.3,0.3-0.6,0.6-0.6l1.8-0.1c0,0,0.1,0,0.1,0l2.1,0.2c0.4,0,0.7-0.3,0.7-0.7l0-2.7c0-0.4-0.3-0.7-0.7-0.7l-2.3,0
				c0,0,0,0-0.1,0l-1.7,0.1c-0.4,0-0.7-0.3-0.7-0.7l0-1.4c0-0.4,0.3-0.7,0.7-0.7l2.1,0.2c0,0,0,0,0.1,0l3,0l2.5-0.1
				c0.4,0,0.7-0.3,0.6-0.7l-0.1-2.5c0-0.4-0.3-0.6-0.6-0.7l-2.6-0.1c0,0,0,0-0.1,0l-3.1,0.2c0,0,0,0,0,0l-3.1,0l-2.6-0.1
				c-0.4,0-0.7,0.3-0.7,0.7l0.1,2.5c0,0,0,0,0,0l0,3l-0.1,3l-0.1,3c0,0,0,0,0,0l0.1,3l0,2.5c0,0.4,0.3,0.7,0.7,0.7l2.1,0l2.6-0.1
				c0,0,0,0,0,0l5.1,0.1l2.2,0.1c0.4,0,0.7-0.3,0.7-0.7L156.1,15.4z"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M25.7,76.6c-3.3-3.4-3.6-3.2-6.8-6.6c-0.7-0.8-1.7-1.4-2.7-1.1c-1,0.3-0.9,0.5-1.9,0.8
					c-1.4,0.4-2.3,2-1.8,3.5c1.1,2.3,1,2.3,2.2,4.6c0.9,1.8,0.2,4-1.7,4.6c-0.6,0.2-0.6,0.2-1.2,0.4c-1.4,0.4-3-0.6-3.4-2
					c-4-12.7-4.2-12.6-8.1-25.3c-0.4-1.4,0.5-2.9,2-3.4c5.8-1.8,5.8-1.9,11.6-3.8c1.4-0.4,2.9-0.5,4.3-0.5c1.4,0,2.6,0.4,3.8,0.9
					c1.2,0.5,2.4,1.1,3.3,2.1c0.9,1,1.6,2.4,2.1,4c0.7,2.3,1,4.4,0.5,6.1c-0.3,1.1-1,2-1.8,3c-0.9,1.1-0.6,2.5,0.3,3.5
					c2.3,2.5,2.4,2.5,4.7,4.9c1.4,1.5,0.7,4.3-1.3,4.9c-0.6,0.2-0.8-0.4-1.4-0.2C27.2,77.4,26.4,77.3,25.7,76.6z M21.1,56.9
					c-0.4-1.4-1.4-2-2.3-2.4c-1-0.4-2.1-0.7-3.5-0.3c-2.7,0.8-2.6,1-5.3,1.9c-1.4,0.4-2.3,2-1.8,3.5c0.4,1.3,0.3,1.3,0.7,2.6
					c0.4,1.4,2.1,2,3.5,1.6c2.7-0.8,2.7-0.8,5.4-1.7C20.7,61.2,22,59.5,21.1,56.9z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M63.4,53.8c0.4,2.4,0.3,4.7,0,6.8c-0.2,2.1-0.6,4.1-1.5,5.8c-0.9,1.6-2.5,2.7-4.1,3.8
					c-1.6,1.1-3.3,1.8-5.5,2.2c-2.2,0.4-4.1,0.6-6,0.2c-1.8-0.5-3.4-1.4-4.8-2.6c-1.4-1.2-2.9-2.6-3.9-4.4c-1-1.9-1.6-4.1-2-6.5
					c-0.4-2.4-0.2-4.6,0.1-6.7c0.2-2.1,0.3-4.2,1.2-5.8c0.9-1.6,2.2-3.1,3.8-4.2c1.5-1.1,3.6-1.7,5.7-2.1c2.2-0.4,4.2-0.5,6.1-0.1
					c1.8,0.5,3.5,1.5,4.9,2.7c1.4,1.2,2.4,2.9,3.4,4.8C61.9,49.4,63,51.4,63.4,53.8z M56.5,55.1c-0.3-1.4-0.4-2.8-0.9-3.9
					c-0.5-1.2-1.3-1.9-2.1-2.7c-0.8-0.8-1.4-1.8-2.4-2.1c-1-0.3-2.3-0.4-3.5-0.2c-1.3,0.2-2.2,1-3.1,1.7c-0.8,0.7-1.6,1.5-2,2.5
					c-0.4,1-0.3,2.2-0.4,3.5c0,1.3-0.1,2.6,0.2,4c0.3,1.4,0.3,2.8,0.8,4c0.5,1.2,1.6,1.8,2.4,2.6c0.8,0.8,1.5,1.3,2.5,1.6
					c1,0.3,2,0.6,3.3,0.4c1.3-0.2,2.2-0.8,3-1.5c0.8-0.7,1.6-1.4,2-2.4c0.4-1,0.9-2.1,0.9-3.4C57.3,57.8,56.7,56.5,56.5,55.1z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M92.4,65.9c-1.1-2.4-0.7-2.6-1.9-5.1c-0.3-0.6-1.2-1.1-1.8-1.1c-4.5,0.2-4.5,0.7-9,0.9
					c-1.1,0.1-2,0.7-2.2,1.8c-0.5,2.5-0.2,2.5-0.7,5c-0.2,0.6-0.8,1.1-1.5,1.2c-1.7,0.2-1.7,0.4-3.5,0.5C70.7,69.2,70,68,70.3,67
					C74.4,52,74,51.9,78.1,37c0.2-0.6,0.9-1.2,1.6-1.3c2-0.2,2-0.1,4.1-0.3c0.6-0.1,1.2,0.4,1.5,0.9c6.9,13.9,7.1,13.7,14,27.6
					c0.5,1-0.3,2.5-1.4,2.6C96,66.8,96,66.8,94.2,67C93.5,67.1,92.7,66.5,92.4,65.9z M84.2,48.6c-0.2-0.4-0.1-1.3-0.5-2.1
					c-0.4-0.8-2.2-0.7-2.4,0.2c-0.2,0.9,0,1.8-0.1,2.2c-0.5,1.9-0.7,1.9-1.1,3.8c-0.3,1,0.6,1.9,1.7,1.8c1.5-0.1,1.5-0.1,2.9-0.2
					c1.1-0.1,1.5-1.1,1-2C84.9,50.5,85.1,50.4,84.2,48.6z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M131.7,49.2c0.1,2.8-0.3,5.2-1.1,7.2c-0.9,2.1-1.8,3.9-3.3,5.3c-1.5,1.3-3.3,2.3-5.3,3
					c-2,0.7-4,0.7-6.1,0.8c-3.4,0.1-3.4,0.5-6.8,0.6c-1.5,0-2.9-1.4-3-2.9c-0.3-13.3-0.2-13.3-0.6-26.6c0-1.5,1.2-2.6,2.7-2.6
					c3.6-0.1,3.6-0.6,7.3-0.7c2.3-0.1,4.4,0.6,6.3,1.1c2,0.5,3.5,1.5,5,2.7c1.5,1.2,2.6,2.7,3.5,4.7
					C131.2,43.8,131.6,46.2,131.7,49.2z M125.5,49.3c-0.1-3.3-1-5.7-2.5-7.3c-1.5-1.6-4.1-2.1-7.5-2c-0.3,0-0.3,0-0.7,0
					c-1.5,0-2.8,1.1-2.8,2.7c0.2,7,0.6,7,0.8,14c0,1.5,1,2.5,2.5,2.5c0.2,0,0.2,0.1,0.4,0.1c1.7,0,3.2-0.1,4.4-0.6
					c1.2-0.5,1.9-1.6,2.7-2.4c0.8-0.9,1.7-1.7,2.1-2.9C125.3,52.2,125.5,50.8,125.5,49.3z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M160.4,42.3c-1.1,0.5-2.2,0.2-3-0.7c-0.3-0.4-0.8-0.6-1.2-0.9c-0.9-0.6-2.1-0.8-3.5-0.9
					c-1.2,0-2.2,0.1-3.2,0.5c-1,0.5-2,0.9-2.6,1.8c-0.7,0.9-0.8,2.1-1.2,3.3c-0.4,1.2-1,2.5-1.1,4c-0.1,1.4,0.3,2.8,0.6,4
					c0.3,1.2,0.8,2.3,1.4,3.2c0.6,0.9,1.2,1.9,2.2,2.4c0.9,0.6,2.1,1,3.3,1c1.5,0.1,2.8-0.4,3.7-1c0.5-0.3,0.7-1,1.2-1.5
					c0.9-1,2.4-0.9,3.5-0.2c0.4,0.3,0.6,0,1.1,0.3c1.4,0.9,1.6,3,0.5,4.2c-0.9,1.1-1.9,1.9-3.1,2.6c-2,1.2-4.4,2-7.4,1.9
					c-2.1-0.1-3.9-1-5.6-1.8c-1.7-0.8-3.3-1.7-4.5-3.2c-1.2-1.5-1.7-3.4-2.3-5.5c-0.6-2.1-1.4-4.3-1.3-6.8c0.1-2.4,0.9-4.6,1.7-6.6
					c0.8-2,1.5-4,2.8-5.4c1.3-1.4,3.1-2.2,4.9-3c1.8-0.7,3.7-1.1,5.8-1.1c1.5,0.1,2.8,0.6,4,1c1.2,0.4,2.4,0.6,3.4,1.3
					c0.9,0.7,1.7,1.6,2.3,2.4c0.1,0.2,0.2,0.2,0.3,0.4c0.9,1.2,0.6,3.2-0.9,3.8C161.3,42.4,161.1,42,160.4,42.3z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M191.8,69.9c-1.1,0-1.9-1-2-2.1c-0.2-2.6-0.5-2.5-0.7-5.1c-0.1-0.6-0.6-1.1-1.2-1.2
					c-4.7-0.5-4.8-0.3-9.5-0.8c-0.7-0.1-1.2,0-1.5,0.6c-1.2,2.4-1.3,2.4-2.4,4.8c-0.3,0.6-0.9,1-1.5,1c-1.8-0.2-1.7-0.3-3.5-0.5
					c-1.1-0.1-1.7-1.3-1.2-2.2c7.1-13.8,7.4-13.6,14.5-27.4c0.3-0.6,0.6-0.8,1.3-0.7c2,0.2,2.1-0.2,4.1,0c0.6,0.1,1.3,0.7,1.5,1.3
					c3.9,15,3.6,15.1,7.5,30.1c0.3,1-0.5,1.7-1.5,1.6C193.6,69.4,193.6,69.8,191.8,69.9z M185.1,46.1c-0.1-0.5-0.8-0.7-1-0.2
					c-1.6,3.3-1.3,3.4-2.9,6.8c-0.5,1,0.1,2,1.1,2.1c1.5,0.2,1.5-0.1,3,0.1c1.1,0.1,1.8-0.5,1.6-1.6
					C185.9,49.7,185.9,49.7,185.1,46.1z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M227.6,65.7c-0.3,1.5-0.7,2.9-1.4,4c-0.7,1.1-1.9,1.8-3.1,2.5c-1.2,0.7-2.5,1.1-4.2,1.3
					c-1.6,0.2-3.5,0.1-5.6-0.3c-2.6-0.5-5-1.3-7-2.7c-1-0.8-2-1.5-2.8-2.5c-1-1.3-0.3-3.1,1.1-3.9c0.4-0.2,0.2-0.6,0.6-0.8
					c1.1-0.7,2.4-0.2,3.3,0.8c0.6,0.6,1.4,1,2.1,1.5c1.3,0.8,2.6,1.4,4.2,1.7c1.9,0.4,3.4,0.4,4.4,0c1-0.4,1.3-1.3,1.5-2.5
					c0.1-0.5,0.5-0.9,0.4-1.3c-0.1-0.4-0.3-0.9-0.8-1.4c-0.4-0.4-1.3-0.5-2.2-1c-0.9-0.5-1.9-1.3-3.3-1.9c-1.4-0.6-2.7-1.1-3.8-1.8
					c-1.1-0.7-2-1.5-2.7-2.4c-0.7-0.9-1.3-1.9-1.5-3c-0.3-1.1-0.3-2.5,0-4.1c0.3-1.4,0.7-2.8,1.6-3.8c0.8-1,2-1.7,3.1-2.3
					c1.2-0.6,2.5-0.7,4-0.9c1.4-0.2,2.9-0.3,4.5,0c2.5,0.5,4.4,1.5,6.1,2.8c0.9,0.6,1.7,1.3,2.4,2.1c1.1,1.2,0.8,2.9-0.6,3.8
					c-0.4,0.3-0.4,0.3-0.8,0.6c-1.1,0.7-2.3,0.7-3.2-0.3c-0.4-0.5-1.1-0.7-1.6-1.1c-1-0.8-2.3-1.1-3.7-1.4c-0.8-0.2-1.5-0.5-2.1-0.4
					c-0.6,0.1-1.1,0.3-1.5,0.5c-0.4,0.2-1,0.1-1.2,0.4c-0.2,0.3,0.2,0.9,0.1,1.2c-0.1,0.5-0.1,0.8,0,1.2c0.1,0.4,0,1,0.4,1.3
					c0.4,0.4,1.1,0.7,1.8,1.1c0.8,0.4,1.7,0.9,2.9,1.5c1.2,0.5,2.4,1.1,3.6,1.7c1.2,0.6,2.3,1.3,3.1,2.2c0.9,0.9,1.5,2,1.9,3.2
					C228,62.5,227.9,64,227.6,65.7z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M251.3,58.7c-2.6,9.9-2.9,9.9-5.5,19.8c-0.4,1.3-1.7,1.9-3,1.4c-1.1-0.4-1.2-0.1-2.4-0.5
					c-1.3-0.4-1.9-1.7-1.5-3c3.1-9.8,2.7-10,5.7-19.8c0.4-1.4,0-3-1.5-3.5c-1.8-0.6-1.8-0.7-3.5-1.2c-1.4-0.4-2.4-1.7-1.9-3.2
					c0.1-0.4,0.2-0.4,0.3-0.7c0.4-1.4,1.9-2,3.3-1.6c9.2,2.9,9.3,2.5,18.6,5.4c1.4,0.4,2.1,2.1,1.7,3.5c-0.1,0.4,0.1,0.4-0.1,0.8
					c-0.4,1.4-2.1,2.5-3.6,2c-1.8-0.6-1.7-1-3.4-1.5C253.1,56.2,251.8,57.3,251.3,58.7z"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M71.9,88.8l-0.5-0.5c-0.1-0.1-0.2-0.1-0.3-0.2l-0.9-0.4c-0.1,0-0.2-0.1-0.4,0L69,87.9
					c-0.1,0-0.3,0.1-0.4,0.2L68,88.7c-0.1,0.1-0.1,0.1-0.1,0.2l-0.4,1c0,0.1,0,0.1-0.1,0.2l-0.1,1.3c0,0,0,0.1,0,0.1l0.1,1.3
					c0,0.1,0,0.2,0.1,0.3l0.5,0.9c0,0,0.1,0.1,0.1,0.1l0.6,0.7c0.1,0.1,0.2,0.2,0.4,0.2l0.8,0.2c0.1,0,0.2,0,0.3,0l1-0.3
					c0.1,0,0.3-0.1,0.4-0.2l0.4-0.5c0.2-0.3,0.6-0.3,0.9-0.1l0.9,0.5c0.3,0.2,0.4,0.6,0.2,0.9L73.7,96c0,0.1-0.1,0.1-0.2,0.2
					l-0.8,0.7c-0.1,0.1-0.1,0.1-0.2,0.1l-1.1,0.4c-0.1,0-0.1,0-0.2,0L70,97.5c-0.1,0-0.1,0-0.2,0L68,97.2c-0.1,0-0.2-0.1-0.3-0.1
					l-1.4-1c-0.1-0.1-0.2-0.1-0.2-0.2l-0.9-1.7c0-0.1-0.1-0.1-0.1-0.2l-0.2-1.1c0,0,0-0.1,0-0.1l-0.1-1.2c0,0,0-0.1,0-0.1l0.4-2.3
					c0-0.1,0-0.1,0.1-0.2l0.9-1.7c0-0.1,0.1-0.2,0.2-0.2l1.4-1c0.1-0.1,0.2-0.1,0.3-0.1l1.9-0.3c0,0,0.1,0,0.2,0l1.3,0.1
					c0.1,0,0.1,0,0.2,0l1,0.4c0.1,0,0.2,0.1,0.3,0.2l0.7,0.8c0,0,0,0,0.1,0.1l0.3,0.4c0.3,0.4,0.1,0.9-0.3,1l-1,0.5
					C72.4,89.1,72.1,89,71.9,88.8z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M83.4,97l-0.5-0.9c0,0,0-0.1-0.1-0.1l-0.5-1.4c0,0,0-0.1-0.1-0.1l-0.5-0.9c-0.2-0.3-0.4-0.4-0.8-0.4l-1.1,0
					c-0.4,0-0.8,0.4-0.8,0.8l0,0.6c0,0,0,0.1,0,0.1l0.1,1.4l0,0.6c0,0.5-0.4,0.9-0.8,0.9l-0.7,0c-0.5,0-0.8-0.4-0.8-0.8l0-0.9
					c0,0,0-0.1,0-0.1l0.2-1.5c0-0.1,0-0.1,0-0.2l-0.1-1.6l-0.1-1.7l0-1.7l0-1.7l0-0.9c0-0.4,0.4-0.8,0.8-0.8l1,0c0,0,0.1,0,0.1,0
					l1.7,0.1c0,0,0.1,0,0.1,0l1.7,0c0,0,0.1,0,0.1,0l1.3,0.1c0.1,0,0.3,0.1,0.4,0.2l0.9,0.7c0.1,0,0.1,0.1,0.2,0.2l0.7,0.9
					c0.1,0.1,0.1,0.2,0.1,0.3l0.4,1.2c0,0.1,0,0.3,0,0.5l-0.4,1.7c-0.1,0.2-0.2,0.4-0.3,0.5l-1,0.7c-0.3,0.2-0.5,0.7-0.3,1l0.4,0.9
					c0,0,0,0,0,0.1l0.8,1.5l0.2,0.4c0.3,0.5-0.1,1.2-0.7,1.2l0,0c0,0-0.1,0-0.1,0L84,97.4C83.7,97.4,83.5,97.2,83.4,97z M83.7,89
					l-0.2-0.4c-0.1-0.2-0.2-0.3-0.4-0.4l-0.7-0.3c-0.1,0-0.2-0.1-0.4-0.1l-1.4,0l-0.8,0c-0.4,0-0.8,0.4-0.8,0.8l0,0.7c0,0,0,0,0,0.1
					l0,0.6c0,0.5,0.4,0.8,0.9,0.8l0.7,0l1.4,0c0.1,0,0.2,0,0.2,0l0.7-0.2c0.2-0.1,0.4-0.2,0.5-0.4l0.2-0.4
					C83.8,89.5,83.8,89.3,83.7,89z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M89.6,97.4c-0.5,0-0.9-0.3-0.9-0.8l0-0.8l0-1.7c0,0,0,0,0-0.1l0.1-1.7l0-1.7l0-1.7c0,0,0,0,0-0.1l0.1-1.6
					c0,0,0-0.1,0-0.1l-0.1-0.7c0-0.5,0.4-0.9,0.9-0.9l0.7,0l1.6-0.1c0,0,0,0,0.1,0l1.6,0c0,0,0,0,0.1,0l1.5,0.2c0.1,0,0.1,0,0.2,0
					l0.6-0.1c0.5,0,0.9,0.4,0.9,0.9l0,0.5c0,0.5-0.4,0.9-0.9,0.9l-1.1,0l-1.9,0c0,0,0,0-0.1,0l-1,0.1c-0.5,0-0.8,0.4-0.8,0.9l0,0.3
					c0,0.4,0.4,0.8,0.8,0.8l0.8,0.1c0,0,0.1,0,0.1,0l0.7,0c0.5,0,0.9,0.4,0.9,0.8l0,0.6c0,0.5-0.3,0.8-0.8,0.9l-0.8,0.1
					c0,0-0.1,0-0.1,0l-0.7,0c-0.5,0-0.9,0.4-0.9,0.9l0,0.4c0,0,0,0,0,0.1l0,0.4c0,0.5,0.4,1,0.9,0.9l0.5,0c0,0,0.1,0,0.1,0l1.4,0.1
					c0,0,0.1,0,0.1,0l1.4-0.1c0,0,0.1,0,0.1,0l0.7,0.1c0.4,0,0.8,0.4,0.8,0.8l0,0.6c0,0.5-0.4,0.9-0.9,0.9l-0.7-0.1c0,0-0.1,0-0.1,0
					l-1.6,0.1l-1.6,0.1c0,0-0.1,0-0.1,0l-1.6-0.1c0,0,0,0-0.1,0L89.6,97.4z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M107.4,96.9l-0.3-0.8c0,0,0-0.1,0-0.1l-0.2-0.8c-0.1-0.3-0.4-0.5-0.7-0.5l-0.9,0l-1.4,0l-0.9,0
					c-0.3,0-0.6,0.2-0.7,0.5l-0.3,0.8c0,0,0,0,0,0.1l-0.3,0.8c-0.1,0.3-0.4,0.5-0.7,0.5l-1,0c-0.5,0-0.9-0.5-0.7-1l0.3-0.8L100,94
					c0,0,0,0,0,0l0.7-1.6l0.7-1.7l0.7-1.7l0.7-1.6c0,0,0-0.1,0-0.1l0.4-1.2c0.1-0.3,0.4-0.5,0.7-0.5l1.2,0c0.3,0,0.6,0.2,0.7,0.5
					l0.5,1.2c0,0,0,0,0,0l0.6,1.7l0.7,1.7l0.7,1.7L109,94c0,0,0,0,0,0l0.6,1.7l0.2,0.7c0.2,0.5-0.2,1-0.7,1l-0.2,0c0,0,0,0,0,0
					l-0.8,0C107.8,97.4,107.5,97.2,107.4,96.9z M105.1,90.3l-0.4-0.8c0,0,0-0.1-0.1-0.1c0,0-0.2-0.7-0.5,0.1c-0.2,0.7-0.3,1-0.3,1
					l-0.4,1.1c-0.2,0.5,0.2,1,0.7,1l0.2,0l0.3,0c0.5,0,0.8-0.5,0.7-1l-0.3-1.1C105.1,90.4,105.1,90.3,105.1,90.3z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M116.3,88c-0.3,0-0.5,0.2-0.5,0.5l0,1l-0.1,1.6c0,0,0,0,0,0.1l0.1,1.5c0,0,0,0,0,0.1l-0.1,1.6l0,1.6
					c0,0,0,0,0,0l0.1,1.1c0,0.3-0.2,0.6-0.6,0.6l-1.3,0c-0.3,0-0.6-0.3-0.5-0.6l0.1-1c0,0,0,0,0-0.1l-0.1-1.5l0-1.6l0-1.6l0-1.6l0-1
					c0-0.3-0.2-0.6-0.5-0.6l-1.1,0c0,0,0,0,0,0l-1.1,0.1c-0.3,0-0.6-0.3-0.6-0.6l0.1-1.2c0-0.3,0.2-0.5,0.5-0.5l1.2-0.1
					c0,0,0.1,0,0.1,0l1.8,0.1l1.8,0.1c0,0,0,0,0.1,0l1.8-0.1c0,0,0,0,0,0l1.3,0c0.3,0,0.5,0.3,0.5,0.6l0,1.2c0,0.3-0.2,0.5-0.5,0.5
					l-1.1,0L116.3,88z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M121.6,96.8l-0.1-1c0,0,0,0,0,0l0-1.6c0,0,0,0,0,0l0.1-1.7l0.1-1.6c0,0,0,0,0-0.1l-0.1-1.6l-0.1-1.7
					c0,0,0,0,0-0.1l0-1c0-0.4,0.3-0.7,0.7-0.6l1.1,0c0.3,0,0.6,0.3,0.6,0.6l0.1,1c0,0,0,0.1,0,0.1l-0.1,1.6c0,0,0,0,0,0.1l0.1,1.6
					c0,0,0,0,0,0l0,1.7l0,1.7l-0.1,1.7c0,0,0,0,0,0l0,1c0,0.4-0.3,0.7-0.7,0.7l-1,0C121.9,97.4,121.6,97.1,121.6,96.8z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M132.3,97.5l-1.4,0c-0.3,0-0.5-0.2-0.6-0.4l-0.5-1.2c0,0,0,0,0-0.1l-0.5-1.7c0,0,0,0,0,0l-0.6-1.7l-0.6-1.6
					c0,0,0,0,0-0.1l-0.7-1.6c0,0,0,0,0-0.1l-0.6-1.6c0,0,0,0,0-0.1l-0.2-0.8c-0.1-0.4,0.2-0.9,0.7-0.8l0.3,0c0,0,0,0,0,0l0.7,0
					c0.3,0,0.6,0.2,0.7,0.5l0.3,1.2c0,0,0,0.1,0,0.1l0.7,1.6c0,0,0,0.1,0,0.1l0.4,1.7c0,0,0,0,0,0l0.5,1.7l0.2,0.5l0.2,0.5
					c0,0,0,0.1,0,0.1l0.2,0.4c0,0,0,0.1,0,0.1l0.1,0.4l0.2-0.9l0.2-1c0,0,0-0.1,0-0.1l0.7-1.5c0,0,0-0.1,0-0.1l0.3-1.6
					c0,0,0-0.1,0-0.1l0.7-1.5c0,0,0-0.1,0-0.1l0.3-1.2c0.1-0.3,0.3-0.5,0.6-0.5l0.8,0c0,0,0,0,0,0l0.4,0c0.5,0,0.8,0.5,0.6,0.9
					l-0.3,0.8c0,0,0,0.1,0,0.1l-0.5,1.7c0,0,0,0,0,0l-0.6,1.6c0,0,0,0,0,0l-0.7,1.6l-0.7,1.6c0,0,0,0,0,0.1l-0.5,1.7L133,97
					C132.9,97.3,132.6,97.5,132.3,97.5z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M139.2,96.5l0.1-0.7c0,0,0,0,0-0.1l0-1.7l0-1.7l0-1.7l0-1.7l0-1.7l0-0.8c0-0.5,0.4-0.9,0.9-0.9l0.8,0l1.6,0
					c0,0,0.1,0,0.1,0l1.5-0.1c0,0,0.1,0,0.1,0l1.6,0l0.8,0c0.4,0,0.8,0.4,0.8,0.8l0,0.7c0,0.5-0.4,0.8-0.8,0.8l-1.1,0l-1.9,0.1
					c0,0-0.1,0-0.1,0l-1.1-0.1c-0.5,0-0.9,0.3-0.9,0.8l0,0.3c0,0.5,0.4,0.9,0.9,0.8l0.8-0.1c0,0,0.1,0,0.1,0l0.9,0
					c0.5,0,0.8,0.4,0.8,0.8l0,0.7c0,0.5-0.4,0.9-0.9,0.8l-0.8-0.1c0,0,0,0-0.1,0l-0.8,0c-0.5,0-0.9,0.4-0.8,0.9l0.1,0.5
					c0,0.1,0,0.1,0,0.2l0,0.5c0,0.5,0.3,0.9,0.8,0.9l0.6,0c0,0,0.1,0,0.1,0l1.4-0.2c0,0,0.1,0,0.1,0l1.4,0c0,0,0,0,0.1,0l0.8,0
					c0.4,0,0.8,0.4,0.8,0.8l0,0.8c0,0.4-0.4,0.8-0.8,0.8l-0.9,0c0,0-0.1,0-0.1,0l-1.6-0.1c0,0,0,0-0.1,0l-1.7,0l-1.6,0
					c0,0-0.1,0-0.1,0l-0.7,0.1C139.6,97.4,139.1,97,139.2,96.5z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M157.3,88.7l0,0.7c0,0.4,0.4,0.8,0.8,0.8l1,0l1,0c0.4,0,0.8,0.3,0.8,0.7l0,0.7c0,0.5-0.4,0.9-0.8,0.8l-1,0
					c0,0,0,0,0,0l-1,0c-0.4,0-0.8,0.3-0.8,0.7l-0.1,0.9c0,0,0,0,0,0.1l0,1.6c0,0,0,0,0,0l0.1,0.8c0,0.5-0.3,0.9-0.8,0.9l-0.8,0
					c-0.4,0-0.8-0.3-0.8-0.8l0-0.9c0,0,0-0.1,0-0.1l0.1-1.6c0,0,0-0.1,0-0.1l-0.1-1.6l0-1.7l0-1.7l0.1-1.7c0,0,0,0,0-0.1l0-0.8
					c0-0.5,0.4-0.8,0.8-0.8l0.8,0c0,0,0,0,0,0l1.6-0.1c0,0,0.1,0,0.1,0l1.6,0.1c0,0,0,0,0,0l1.6,0c0,0,0,0,0.1,0l0.8-0.1
					c0.5,0,0.9,0.4,0.9,0.8l0,0.6c0,0.4-0.4,0.8-0.8,0.7l-0.7,0c0,0,0,0,0,0l-1.5,0l-1.5,0l-0.8,0C157.7,87.9,157.3,88.2,157.3,88.7
					z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M173.7,96.3l-1.4,0.9c-0.1,0-0.2,0.1-0.2,0.1l-1.6,0.3c-0.1,0-0.2,0-0.3,0l-1.7-0.3c-0.1,0-0.2-0.1-0.3-0.1
					l-1.3-0.8c-0.1-0.1-0.2-0.2-0.3-0.3l-0.8-1.4c-0.1-0.1-0.1-0.2-0.1-0.3l-0.1-2.1c0,0,0,0,0,0l0-1.6l0-1.6c0,0,0-0.1,0-0.1
					l-0.2-1.5c0-0.1,0-0.1,0-0.2l0.1-0.9c0-0.4,0.3-0.6,0.7-0.7l0.9-0.1c0.4,0,0.8,0.3,0.8,0.7l0,0.9l0,1.6c0,0,0,0,0,0.1l-0.1,1.6
					c0,0,0,0,0,0l0,1.5c0,0.1,0,0.2,0,0.3l0.7,1.8c0.1,0.2,0.2,0.3,0.4,0.4l1.1,0.5c0.2,0.1,0.4,0.1,0.6,0l1.1-0.5
					c0.2-0.1,0.3-0.2,0.4-0.4l0.7-1.8c0-0.1,0-0.2,0-0.2l0-1.5c0,0,0-0.1,0-0.1l-0.1-1.6c0,0,0,0,0-0.1l0-1.6l0-1
					c0-0.4,0.3-0.8,0.8-0.8l0.9,0c0.4,0,0.8,0.4,0.7,0.8l0,1l-0.1,1.6c0,0,0,0,0,0.1l0.1,1.6l0,1.6c0,0,0,0,0,0l-0.1,1.4
					c0,0,0,0,0,0.1l-0.2,1.2c0,0.1-0.1,0.2-0.1,0.3l-0.7,0.9C173.8,96.2,173.8,96.2,173.7,96.3z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M178.8,97.4c-0.4,0-0.8-0.4-0.8-0.8l0-0.9l0.1-1.6c0,0,0-0.1,0-0.1l-0.1-1.6c0,0,0,0,0-0.1l0-1.7l0.1-1.6
					c0,0,0-0.1,0-0.1l-0.1-1.6c0,0,0-0.1,0-0.1l0-0.8c0-0.5,0.4-0.8,0.9-0.8l0.8,0c0,0,0,0,0,0l1.6,0c0,0,0,0,0.1,0l1.5-0.1
					c0.1,0,0.1,0,0.2,0l1.5,0.2c0,0,0.1,0,0.1,0l0.7,0c0.5,0,0.9,0.4,0.9,0.8l0,0.6c0,0.5-0.4,0.8-0.8,0.8l-1.1,0l-1.9,0l-1.1,0
					c-0.5,0-0.8,0.4-0.8,0.9l0,0.3c0,0.4,0.4,0.8,0.8,0.8l0.8,0l0.9,0c0.5,0,0.8,0.4,0.8,0.8l0,0.7c0,0.5-0.4,0.9-0.9,0.8l-0.8,0
					c0,0,0,0-0.1,0l-0.9,0c-0.5,0-0.8,0.4-0.8,0.9l0,0.6l0,0.6c0,0.4,0.3,0.8,0.8,0.8l0.7,0.1c0,0,0.1,0,0.1,0l1.5,0l1.5,0l0.7,0
					c0.5,0,0.9,0.4,0.8,0.8l0,0.7c0,0.4-0.4,0.8-0.8,0.8l-0.9,0c0,0,0,0-0.1,0l-1.6,0c0,0,0,0,0,0l-1.6,0.1c0,0,0,0,0,0l-1.6,0
					c0,0,0,0-0.1,0L178.8,97.4z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              style={{ fill: '#223320' }}
              d="M189.7,97.4c-0.4,0-0.7-0.3-0.7-0.7l0-0.9l-0.1-1.7c0,0,0,0,0,0l0-1.7l0.1-1.6c0,0,0-0.1,0-0.1L189,89
					l0-1.7c0,0,0,0,0,0l0-0.9c0-0.4,0.3-0.7,0.7-0.7l0.8,0c0.4,0,0.7,0.3,0.7,0.7l0,0.8c0,0,0,0,0,0.1l0.1,1.6l0.1,1.5
					c0,0,0,0.1,0,0.1l-0.1,1.5c0,0,0,0,0,0.1l0,1.5l0,0.9c0,0.4,0.3,0.7,0.7,0.7l1.2,0c0,0,0,0,0.1,0l1.9-0.1c0,0,0.1,0,0.1,0
					l1.2,0.1c0.4,0,0.7,0.3,0.7,0.7l0,0.8c0,0.4-0.3,0.7-0.7,0.7l-0.9,0l-1.6-0.1c0,0,0,0-0.1,0l-1.6,0.1c0,0,0,0,0,0l-1.6,0
					L189.7,97.4z"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#223320' }}
            d="M209.4,91.7c-2,1.7-1.7,2-3.7,3.7c-0.3,0.3-0.9-0.1-0.9-0.5c0-3.4-0.3-3.4-0.3-6.8c0-0.4,0.7-0.6,1-0.3
				c2,1.7,2,1.6,4,3.4C209.8,91.3,209.7,91.5,209.4,91.7z"
          />
        </g>
        <g>
          <path
            style={{ fill: '#223320' }}
            d="M50.6,91.7c2,1.7,1.7,2,3.7,3.7c0.3,0.3,1.1-0.1,1.1-0.5c0-3.4-0.4-3.4-0.4-6.8c0-0.4-0.4-0.7-0.7-0.5
				c-2,1.7-1.9,1.8-3.9,3.5C50.2,91.3,50.4,91.5,50.6,91.7z"
          />
        </g>
      </g>
    </g>
  </svg>
)
